/* Keep Judge.me in charge of filtering, sorting, and review submission. */
if (window.jdgmSettings) window.jdgmSettings.all_reviews_widget_v2025_review_dates = true;
if (!customElements.get('ps-reviews')) {
  customElements.define('ps-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.filterDismissed = false;
      const syncFilterDisclosure = () => {
        const panel = this.querySelector('.jm-filter-panel');
        const button = this.querySelector('.jm-custom-answer-filter');
        if (panel) panel.hidden = this.filterDismissed;
        const expanded = String(Boolean(panel && !this.filterDismissed));
        if (button && button.getAttribute('aria-expanded') !== expanded) {
          button.setAttribute('aria-expanded', expanded);
        }
      };
      const dismissFilter = () => {
        this.filterDismissed = true;
        syncFilterDisclosure();
      };
      const updateLabels = () => {
        this.querySelectorAll('.jm-reviewer-info__details > .jm-cluster:nth-child(2) .jm-text').forEach((element) => {
          const match = element.textContent.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
          if (!match) return;
          const date = new Date(Date.UTC(Number(match[3]), Number(match[1]) - 1, Number(match[2])));
          element.textContent = new Intl.DateTimeFormat('en-US', {
            month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC',
          }).format(date);
        });
        const rating = this.querySelector('.ps-reviews__rating');
        const nativeRating = this.querySelector('.jm-review-widget-header .jm-average-rating-display');
        const nativeRatingText = nativeRating?.textContent.trim();
        if (rating && nativeRating && rating.dataset.nativeRatingText !== nativeRatingText) {
          const ratingDisplay = nativeRating.cloneNode(true);
          const verifiedBadge = [...ratingDisplay.querySelectorAll('*')].find((element) =>
            /^\(?verified\)?$/i.test(element.textContent.trim()) &&
            !/^\(?verified\)?$/i.test(element.parentElement?.textContent.trim() || '')
          );
          verifiedBadge?.remove();
          rating.replaceChildren(ratingDisplay);
          rating.dataset.nativeRatingText = nativeRatingText;
          rating.hidden = false;
        }
        const shopAverageRatingLabel = rating?.dataset.shopAverageRatingLabel?.trim();
        const shopReviewCountLabel = rating?.dataset.shopReviewCountLabel?.trim();
        const displayedAverageRating = rating?.querySelector('.jm-average-rating-display .jm-text:first-of-type');
        const displayedReviewCount = rating?.querySelector('.jm-average-rating-display .jm-text:last-of-type');
        if (displayedAverageRating && shopAverageRatingLabel &&
            displayedAverageRating.textContent !== shopAverageRatingLabel) {
          displayedAverageRating.textContent = shopAverageRatingLabel;
        }
        if (displayedReviewCount && shopReviewCountLabel &&
            displayedReviewCount.textContent !== shopReviewCountLabel) {
          displayedReviewCount.textContent = shopReviewCountLabel;
        }
        const labels = [
          ['.jm-action-buttons__button', 'Leave a review'],
          ['.jm-custom-answer-filter__text', 'Filter'],
          ['.jm-sort-filter__select option[value="created_at"]', 'Latest'],
        ];
        for (const [selector, text] of labels) {
          const element = this.querySelector(selector);
          if (element && element.textContent !== text) element.textContent = text;
        }
        this.querySelectorAll(
          '.jm-sort-filter__select option[value="with_pictures"], ' +
          '.jm-sort-filter__select option[value="pictures_first"], ' +
          '.jm-sort-filter__select option[value="videos_first"]'
        ).forEach((option) => option.remove());
        this.querySelectorAll('.jm-review-item .jm-media-thumbnail-list__thumbnail').forEach((thumbnail) => {
          thumbnail.closest('.jm-cluster')?.classList.add('ps-review-media');
        });
        syncFilterDisclosure();
      };
      const loadShopSummary = async () => {
        const endpoint = this.dataset.shopReviewSummaryUrl;
        if (!endpoint) return;

        try {
          const response = await fetch(endpoint, {
            headers: { Accept: 'application/json' },
            signal,
          });
          if (!response.ok) return;

          const summary = await response.json();
          const averageRatingLabel = typeof summary.averageRatingLabel === 'string'
            ? summary.averageRatingLabel.trim()
            : '';
          const reviewCountLabel = typeof summary.reviewCountLabel === 'string'
            ? summary.reviewCountLabel.trim()
            : '';
          const validRating = /^[1-5](?:[.,]\d+)?$/.test(averageRatingLabel);
          const validReviewCount = /^(?:\d{1,3}(?:,\d{3})+|\d+(?:[.,]\d+)?)\s*[KMB]?\s+Reviews?$/i
            .test(reviewCountLabel);
          if (!validRating || !validReviewCount) return;

          const rating = this.querySelector('.ps-reviews__rating');
          if (!rating) return;
          rating.dataset.shopAverageRatingLabel = averageRatingLabel;
          rating.dataset.shopReviewCountLabel = reviewCountLabel;
          updateLabels();
        } catch (error) {
          if (error.name !== 'AbortError') return;
        }
      };
      this.observer = new MutationObserver(updateLabels);
      this.observer.observe(this, {
        childList: true, subtree: true, characterData: true, attributes: true,
        attributeFilter: ['aria-expanded'],
      });
      updateLabels();
      void loadShopSummary();

      // The app's toggle also clears applied ratings. Manage disclosure locally
      // once its panel exists, leaving the app in charge of the filter values.
      this.addEventListener('click', (event) => {
        if (event.target.closest('.jm-histogram-row')) {
          dismissFilter();
        }
        const button = event.target.closest('.jm-custom-answer-filter');
        if (button && this.querySelector('.jm-filter-panel')) {
          event.preventDefault();
          event.stopPropagation();
          this.filterDismissed = !this.filterDismissed;
          syncFilterDisclosure();
        } else if (button) {
          this.filterDismissed = false;
        }
      }, { capture: true, signal });

      const openFilter = () => this.querySelector('.jm-custom-answer-filter[aria-expanded="true"]');
      document.addEventListener('click', (event) => {
        const button = openFilter();
        if (button && !button.contains(event.target) &&
            !event.target.closest('.jm-filter-panel, .jm-histogram-row')) dismissFilter();
      }, { signal });
      this.addEventListener('keydown', (event) => {
        // Rating shortcuts apply immediately without opening the filter panel.
        if ((event.key === 'Enter' || event.key === ' ') &&
            event.target.closest('.jm-histogram-row')) dismissFilter();
        const button = openFilter();
        if (event.key === 'Escape' && button) {
          event.preventDefault();
          dismissFilter();
          button.focus();
        }
      }, { capture: true, signal });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}
